import { Injectable } from '@angular/core';
import { concat, Observable, of } from 'rxjs';
import { first, map, switchMap, tap } from 'rxjs/operators';

import { SessionApiRepository } from '../repositories/session-api.repository';
import { Transaction } from '../transaction/transaction';
import { UserApiRepository } from '../repositories/user-api.repository';
import { UserCacheRepository } from '../repositories/user-cache.repository';
import { UserInterface } from '../data';

@Injectable()
export class UserProvider {
    constructor(
        private sessionApiRepository: SessionApiRepository,
        private userApiRepository: UserApiRepository,
        private userCacheRepository: UserCacheRepository
    ) {}

    profile(): Observable<Transaction<UserInterface>> {
        return concat(
            this.userCacheRepository.load(),
            this.userApiRepository.load().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.userCacheRepository.save(transaction.data).subscribe();
                    }
                })
            )
        ).pipe(
            first(),
            switchMap(
                (transaction: Transaction<UserInterface>): Observable<Transaction<UserInterface>> =>
                    transaction.map(
                        (user) =>
                            this.sessionApiRepository.load().pipe(
                                map((transactionSession) =>
                                    transactionSession.map(
                                        (session) => {
                                            user.isAdmin = session.admin;
                                            user.isAdminPBC = session.isAdminPBC;
                                            return Transaction.success(user);
                                        },
                                        (throwable) => Transaction.error(throwable.message)
                                    )
                                )
                            ),
                        (throwable) => of(Transaction.error(throwable.message))
                    )
            )
        );
    }
}
